import useMatchmakerQuestion from './useMatchmakerQuestion';

export default function useFunctionCategoriesAnswer() {
  const {
    inputs: { functionCategories },
  } = useMatchmakerQuestion({
    key: 'functionCategories',
    initialState: state => state.functionCategories?.split('-')[1],
  });

  return { selectedFunctionCategoryCode: functionCategories };
}
